var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup162(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_75_2374)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_2374)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_2374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8744 24.2927C22.8584 24.073 22.8477 23.8529 22.8423 23.6327C25.1789 23.3935 26.8188 22.8334 26.8188 22.1798C26.8124 22.1798 26.8133 22.1523 26.8133 22.1422C25.0661 20.5674 28.3276 9.3822 22.2566 9.6077C21.6783 9.17379 20.9653 8.9582 20.2436 8.99904H20.2509C12.0275 9.62054 15.6639 20.1851 13.7893 22.1789H13.7856C13.793 22.8187 15.377 23.3687 17.6457 23.6144C17.6393 23.7702 17.6256 23.9636 17.5962 24.2872C16.6548 26.8264 10.2977 26.115 10.0044 31H30.4406C30.1481 26.1141 23.8167 26.8255 22.8744 24.2927Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_2374",
    x: 8.00439,
    y: 8.99414,
    width: 24.436,
    height: 26.0059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_2374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_2374",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_2374",
    x1: 20,
    y1: -4.8,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005453"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_2374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.174,
    height: 22,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup162);
export default __webpack_public_path__ + "static/media/group162.93a84e9ba2980148996cb3c24a72e4d7.svg";
export { ForwardRef as ReactComponent };